import { AlertType } from '../components/common/AlertMessage';

// 全局认证状态管理
class AuthManager {
  private static instance: AuthManager;
  private alertCallback: ((type: AlertType, message: string) => void) | null = null;
  private navigateCallback: ((path: string) => void) | null = null;

  private constructor() {}

  public static getInstance(): AuthManager {
    if (!AuthManager.instance) {
      AuthManager.instance = new AuthManager();
    }
    return AuthManager.instance;
  }

  // 设置Alert回调函数
  public setAlertCallback(callback: (type: AlertType, message: string) => void) {
    this.alertCallback = callback;
  }

  // 设置导航回调函数
  public setNavigateCallback(callback: (path: string) => void) {
    this.navigateCallback = callback;
  }

  // 处理token过期
  public handleTokenExpired() {
    // 清除本地存储的token
    localStorage.removeItem('token');
    
    // 设置token过期标记，用于登录页面显示提示
    localStorage.setItem('tokenExpired', 'true');
    
    // 显示提示信息
    if (this.alertCallback) {
      this.alertCallback('error', '登录验证失效，请重新登录');
    }

    // 延迟跳转到登录页，让用户看到提示信息
    setTimeout(() => {
      if (this.navigateCallback) {
        this.navigateCallback('/login?expired=true');
      } else {
        // 如果没有设置导航回调，使用window.location
        window.location.href = '/login?expired=true';
      }
    }, 1500); // 1.5秒后跳转，让用户看到提示
  }

  // 检查响应是否表示token过期
  public isTokenExpiredResponse(status: number, errorData?: any): boolean {
    // HTTP状态码401表示未授权
    if (status === 401) {
      return true;
    }

    // 检查业务状态码
    if (errorData?.code === 401) {
      return true;
    }

    // 仅在文案明确指向登录态时才踢下线，避免 INVALID_FILE 等业务错误误匹配 invalid
    const errorMessage = String(
      errorData?.error || errorData?.message || errorData?.msg || ""
    ).toLowerCase();
    if (!errorMessage) return false;

    const tokenExpiredPhrases = [
      "token expired",
      "token invalid",
      "invalid token",
      "unauthorized",
      "未授权",
      "登录过期",
      "登录失效",
      "token过期",
      "token 过期",
      "登录验证失效",
    ];

    return tokenExpiredPhrases.some((phrase) => errorMessage.includes(phrase));
  }
}

export const authManager = AuthManager.getInstance();
